import {
  IconHeadset, IconLayoutBoard, IconRefresh, IconPalette,
  IconGridDots, IconPhoneCall, IconStack2, IconParking, IconMail, IconAddressBook, IconUsersGroup,
  IconPlayerPause, IconPlayerPlay, IconArrowsExchange, IconCircleDot, IconPhoneOff, IconPhone,
  IconArrowBackUp, IconLogout, IconArrowForward, IconTrash, IconX, IconList, IconPhoneOutgoing,
  // Added this pass:
  IconAlertTriangle, IconCircleCheck, IconInfoCircle, IconExclamationCircle,
  IconBackspace, IconPhoneIncoming, IconPhoneX, IconPhoneCheck, IconBellOff, IconBell,
  IconHeadphones, IconMicrophone, IconUserPlus, IconHistory, IconMailOpened,
  IconWifiOff, IconKeyboard, IconDotsVertical, IconChevronDown, IconArrowDownLeft, IconArrowUpRight,
  type Icon as TablerIcon
} from '@tabler/icons-react'

export {
  IconHeadset, IconLayoutBoard, IconRefresh, IconPalette,
  IconGridDots, IconPhoneCall, IconStack2, IconParking, IconMail, IconAddressBook, IconUsersGroup,
  IconPlayerPause, IconPlayerPlay, IconArrowsExchange, IconCircleDot, IconPhoneOff, IconPhone,
  IconArrowBackUp, IconLogout, IconArrowForward, IconTrash, IconX, IconList, IconPhoneOutgoing,
  IconAlertTriangle, IconCircleCheck, IconInfoCircle, IconExclamationCircle,
  IconBackspace, IconPhoneIncoming, IconPhoneX, IconPhoneCheck, IconBellOff, IconBell,
  IconHeadphones, IconMicrophone, IconUserPlus, IconHistory, IconMailOpened,
  IconWifiOff, IconKeyboard, IconDotsVertical, IconChevronDown, IconArrowDownLeft, IconArrowUpRight
}

// Panel id -> header icon.
export const PANEL_ICON: Record<string, TablerIcon> = {
  extensions: IconGridDots,
  mycalls: IconPhoneCall,
  queuedetail: IconUsersGroup,
  parked: IconParking,
  queues: IconStack2,
  voicemail: IconMail,
  contacts: IconAddressBook,
  history: IconHistory
}
